module.exports = __webpack_public_path__ + "media/media/product-card/accessory-1-b867b1190ca5e97d1107671551027a54.png";